import React from 'react';

import {
  makeMapStateToPropsFactory,
  PoiGetter,
} from 'components/cards/listing/makeMapStateToPropsFactory';
import { connect } from 'react-redux';
import {
  LinkedUniversalCard,
  LinkedUniversalCardProps,
} from 'components/cards/listing/UniversalCard/LinkedUniversalCard';
import CardWithControls, { CardWithControlsProps } from 'components/cards/listing/CardWithControls';
import { favoritesAndShortlistDictSelector } from 'store/state/domainData/selectors/favorites';


const shortlistPoiByIdSelector: PoiGetter = (state, id) => favoritesAndShortlistDictSelector(state)[id];


const makeMapStateToProps = makeMapStateToPropsFactory(shortlistPoiByIdSelector);

type UniversalCardSwitcherProps = (LinkedUniversalCardProps | CardWithControlsProps) & { hasControls?: boolean, noTags?: boolean, isListCard?: boolean };

const UniversalCardSwitcher: React.FC<UniversalCardSwitcherProps> = ({ hasControls, noTags, ...props }) => (
  hasControls ? <CardWithControls showPriceDropLabel {...props} hideTags={noTags} /> : <LinkedUniversalCard showPriceDropLabel {...props} hideTags={noTags}/>
);

export default connect(makeMapStateToProps)(UniversalCardSwitcher);
